import React from 'react'
import OpportunityCardSkeleton from './OpportunityCardSkeleton'

interface OpportunitySectionSkeletonProps {
  title: string
  color: string
  cardCount: number
  borderBottom?: boolean
}

const OpportunitySectionSkeleton = ({
  title,
  color,
  cardCount,
  borderBottom = true,
}: OpportunitySectionSkeletonProps) => {
  return (
    <div className={`mb-8 pb-8 ${borderBottom ? 'border-b border-gray-200' : ''}`}>
      <h3 className="text-lg font-medium mb-4 flex items-center gap-2">
        <div className="w-2 h-2 rounded-full" style={{ backgroundColor: color }} />
        <span className="text-gray-700 uppercase">{title}</span>
      </h3>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-5">
        {Array.from({ length: cardCount }).map((_, index) => (
          <OpportunityCardSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}

export default OpportunitySectionSkeleton
